import { render, staticRenderFns } from "./TopMatches.vue?vue&type=template&id=0421de74&scoped=true&"
import script from "./TopMatches.vue?vue&type=script&lang=js&"
export * from "./TopMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421de74",
  null
  
)

export default component.exports